import { getGoApiUrl } from "@/common/http.header";
import { footerTags } from "@/constants/common";
export const formatSelectOption = (
  data,
  labelfield,
  valueField,
  dateField = ""
) => {
  const results = data?.map((val) => {
    val.label = val[labelfield] ? val[labelfield] : "";
    val.id = val[valueField] ? val[valueField] : "";
    if (dateField) {
      val.lastUpdated = val[dateField] ? val[dateField] : "";
    }
    return val;
  });

  return results;
};

export const getErrorMessage = (err) => {
  if (err.errors && err.errors[0]?.message) {
    return err.errors[0].message;
  } else if (err.message) {
    return err.message;
  }
  return "";
};

export const getOrdinalSuffix = (i) => {
  const j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
};

export const getCreativeThumbUrl = (campId) => {
  return (
    'url("' +
    getGoApiUrl() +
    "panel/camp-image/" +
    campId +
    "_300" +
    "/preview.jpg" +
    '")'
  );
};

export const useDebounce = () => {
  let timeout = null;
  return (fnc, delayMs) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fnc();
    }, delayMs || 100);
  };
};

export const hasPermission = (val) => {
  return parseInt(window.localStorage.getItem("permission") || "5") <= val;
};

export const dummyRows = function (rows = 10) {
  return Array.apply(null, { length: rows }).map(() => ({}));
};

export const replaceTags = (html) => {
  for (const tag in footerTags) {
    if (hasKey(footerTags, tag)) {
      const text = footerTags[tag];
      const re = new RegExp(
        `(href=(['"]))(?:(?!\\2).)*?%%${tag}%%(?:(?!\\2).)*?\\2`,
        "g"
      );
      html = html
        .replace(re, `$1javascript:void(0)$2`)
        .replace(
          new RegExp(`%%${tag}%%`, "g"),
          `<a href="javascript:void(0)">${text}</a>`
        );
    }
  }
  return html;
};

export const htmlEntities = (str) => {
  return str.replace(/[\u00A0-\u9999<>&]/gim, function (i) {
    return "&#" + i.charCodeAt(0) + ";";
  });
};

export const getHtml = (html, plaintext) => {
  if (!html && !plaintext) {
    return require("@/assets/sample/iframe-sample.html").default;
  }
  if (!html) {
    return htmlEntities(plaintext || "").replace(/\n/g, "<br />");
  }
  return replaceTags(html);
};

export const previewLinkFormat = (content) => {
  return content
    .replace(new RegExp("target=['|\"]_([a-z]+)['|\"]", "g"), "")
    .replace(new RegExp("href=[\"|']#[\"|']", "g"), 'href="javascript:void(0)"')
    .replace(new RegExp("href=", "g"), 'target="_blank" href=')
    .replace(
      new RegExp(
        'target="_blank" href=["|\']javascript:void\\(0\\)[\'""]',
        "g"
      ),
      'href="javascript:void(0)"'
    );
};

export const isUnsubscribeDisabledOnClient = () => {
  var ids = process.env.VUE_APP_UNSUBSCRIBE_DISABLED_CLIENTS.split(",");
  var loginData = JSON.parse(window.localStorage.getItem("login_data"));
  return ids.includes(loginData.cid + "");
};

export const getFooter = (html, permRemind) => {
  var unsubscribe =
    '<tr><td style="line-height: 25px;"><p style="font-size:12px; margin: 0;">If you wish to opt out of all type of emails, click <a style="color: #0096c7;" href="javascript:void(0)">Unsubscribe</a>.</p></td></tr>';
  if (
    isUnsubscribeDisabledOnClient() ||
    (html + permRemind).indexOf("%%unsubscribe%%") !== -1
  ) {
    unsubscribe = "";
  }
  permRemind = permRemind
    ? `<tr><td style="line-height: 25px;">` +
      replaceTags(permRemind) +
      "</td></tr>"
    : "";
  return (
    '<table cellspacing="0" cellpadding="0" border="0" width="100%" style="font-family:arial,sans-serif; font-size:12px; color:#888888; margin: 20px 0; width: 100%; text-align:center;">' +
    permRemind +
    unsubscribe +
    "</table>"
  );
};

export const floorFigure = (figure, decimals = 2) => {
  const d = Math.pow(10, decimals);
  return (Math.floor(figure * d) / d).toFixed(decimals);
};
export const calculatePercentage = (sum, total) => {
  const parsedTotal = parseInt(total);
  const parsedSum = parseInt(sum);
  if (parsedSum === 0 || parsedTotal === 0) {
    return 0;
  }
  let percentage = (parsedSum / parsedTotal) * 100 || 0;
  return floorFigure(percentage);
};
export const convertCount = (count) => {
  count = parseInt(count);
  if (isNaN(count)) return count;
  return count.toLocaleString();
};
export const hasKey = (obj, key) => {
  if (!isObject(obj)) return false;
  return Object.prototype.hasOwnProperty.call(obj, key);
};
export const isObject = (obj) => {
  return obj !== null && typeof obj === "object";
};
export const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;
  if (!isObject(obj1) || !isObject(obj2)) return false;
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  keys1.sort();
  keys2.sort();
  for (let i = 0; i < keys1.length; i++) {
    if (keys1[i] !== keys2[i]) return false;
    if (!deepEqual(obj1[keys1[i]], obj2[keys2[i]])) return false;
  }
  return true;
};

export const arrayEqual = (arr1, arr2) => {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();
  return sortedArr1.every((value, index) => value === sortedArr2[index]);
};

export const formatNumber = (num) => {
  return (
    new Intl.NumberFormat("en-US", { style: "decimal" }).format(
      parseInt(num || 0)
    ) || 0
  );
};

export const htmlDecode = (input) => {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
};
